<template>
  <div class="discount">
    <div class="head_btn">限时折扣</div>
    <div class="content">
      <div class="operation">
        <div>
          <el-button type="primary" @click="addDiscount" size="small">新建活动</el-button>
        </div>
        <div style="width: 350px;display: flex;align-items: center">
          <div style="width:100px;font-size: 14px">优惠码名称</div>
          <el-input size="small" placeholder="请输入内容" :label="优惠码名称" v-model="input3" class="input-with-select">
            <el-button slot="append" icon="el-icon-search"></el-button>
          </el-input>
        </div>
      </div>

      <div class="tables">
        <template>
          <el-table
            ref="multipleTable"
            :data="tableData"
            tooltip-effect="dark"
            style="width: 100%"
            @selection-change="handleSelectionChange"
          >
            <el-table-column label="活动名称">
              <template slot-scope="scope">{{ scope.row.date }}</template>
            </el-table-column>
            <el-table-column prop="name" label="状态"></el-table-column>
            <el-table-column prop="address" label="付款金额"></el-table-column>
            <el-table-column prop="address" label="支付订单"></el-table-column>
            <el-table-column prop="address" label="参与客户"></el-table-column>
            <el-table-column label="操作">
              <template slot-scope="scope">
                <el-button type="text" size="small">编辑</el-button>
                <el-button type="text" size="small">删除</el-button>
                <el-button type="text" size="small">码率</el-button>
                <el-button type="text" size="small">统计</el-button>
              </template>
            </el-table-column>
          </el-table>
        </template>
      </div>

      <div class="block">
        <el-pagination
          :current-page="currentPage4"
          :page-sizes="[100, 200, 300, 400]"
          :page-size="100"
          layout="total, sizes, prev, pager, next, jumper"
          :total="400"
        ></el-pagination>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      multipleSelection: [],
      input3: "",
      selectData: ["蚵仔煎", "双皮奶"],
      tableData: [],
      currentPage4: 400   
    };
  },
  methods: {
    handleSelectionChange(val) {
      this.multipleSelection = val;
    },
    addDiscount() {
      this.$router.push("addDiscountRule")
    }
  }
};
</script>

<style lang="scss" scoped>
.discount {
  padding: 0 10px;
  padding-right: 25px;
  height: 100%;
  /*background: #f1f2f6;*/
  overflow: auto;
  border-left: 1px solid #f1f2f6;

  .head_btn {
    height: 50px;
    line-height: 50px;
    padding: 0 8px;
    font-size: 16px;
    background: rgba(255, 255, 255, 0.98);
  }

  .content {
    min-height: 300px;
    /*background: #f1f2f6;*/
    /*padding: 10px;*/

    .operation {
      padding: 8px;
      padding-left: 20px;
      background: #fff;
      border-radius: 5px;
      /*margin-bottom: 10px;*/
      display: flex;
      justify-content: space-between;

      .el-dropdown {
        margin-left: 10px;
      }
    }

    .tables {
      margin-top: 10px;
      padding-left: 13px;
      background: #fff;
    }
    .block {
      margin-top: 15px;
      display: flex;
      justify-content: flex-end;
    }
  }
}
</style>

<style lang="scss">
.discount {
  thead {
    th {
      background: #f1efef;
    }
  }
}
</style>